export default "__VITE_ASSET__Dq66BUis__"